import { z } from "zod";
import { useQuery } from "@tanstack/react-query";
import { useToken } from "./use-token";
import { useShop } from "@/hooks/use-shop.ts";
import { api } from "@/lib/server";

export const UserSchema = z.object({
  id: z.coerce.string(),
  locked: z.boolean(),
  pushToken: z.string().nullable(),
  pushNews: z.boolean().nullable(),
  calendarEventSetting: z.boolean().nullable(),
  unlockToken: z.string().nullable(),
  lastName: z.string(),
  firstName: z.string(),
  email: z.string().email(),
  phoneNumber: z.string().nullable(),
  birthdate: z
    .string()
    .datetime()
    .transform((elem) => new Date(elem))
    .nullable(),
  gender: z.enum(["male", "female", ""]).nullable(),
  education: z.string().nullable(),
  residence: z.string().nullable(),
  zip: z.coerce.string().nullish(),
  maritalStatus: z.string().nullable(),
  detailedRegistration: z.boolean().nullable(),
  locale: z.string(),
  city: z.string().nullable(),
  billingName: z.string().nullable(),
  taxnum: z.string().nullable(),
  encryptedPin: z.string().nullable(),
  // registrationSource: z.enum(["web", "mobile", "api"]).nullable(),
  username: z.string().nullable(),
  password: z.string().nullable(),
  currency: z.string(),
  allowCurrencySwitch: z.boolean(),
  favourites: z.array(z.coerce.number()),
  balance: z.coerce.number().nonnegative(),
  // Older cash-agents don't send it yet.
  kioskAudioMuted: z.boolean().nullish(),
});

export type User = z.infer<typeof UserSchema>;

export function useUser() {
  const token = useToken();
  const { data: shop } = useShop();
  return useQuery({
    queryKey: ["user", token, shop?.currencyCode],
    enabled: !!token && !!shop,
    queryFn: async () => {
      const value = await api.whoAmI();
      setUser(value);
      return value;
    },
  });
}

export function setUser(user: User) {
  sessionStorage.setItem("user", JSON.stringify(user));
}
